module.exports = __webpack_public_path__ + "img/58.14a8ee88.png";